import React from "react";
import MenuTable from "./MenuTable";
import { useQuery } from "@tanstack/react-query";

const data = [
  {
    sl: 101,
    Menu_name: "Dashboard",
    active_status: true,
    menu_route: "/dashboard",
  },
  { sl: 102, Menu_name: "Security", active_status: false, menu_route: "" },
  { sl: 103, Menu_name: "Setup", active_status: true, menu_route: "" },
  { sl: 104, Menu_name: "Volunteer Bank", active_status: true, menu_route: "" },
  {
    sl: 105,
    Menu_name: "Study Compliance",
    active_status: false,
    menu_route: "study",
  },
];

const Menu = () => {
  const {
    refetch,
    isLoading,
    isError,
    error,
    isSuccess,
    data: moduleInfo = [],
  } = useQuery({
    queryKey: ["moduleInfo"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/moduleSetup`
      );
      const data = await res.json();
      return data;
    },
  });

  // console.log(moduleInfo);

  return (
    <>
      <MenuTable data={moduleInfo} refetch={refetch} />
    </>
  );
};

export default Menu;
